import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import EscalationsMonitoring from './pages/escalations-monitoring';
import KnowledgeBaseAnalytics from './pages/knowledge-base-analytics';
import AnalyticsOverview from './pages/analytics-overview';
import AgentPerformance from './pages/agent-performance';
import CallHistoryAnalytics from './pages/call-history-analytics';
import NPSAnalytics from './pages/nps-analytics';
import Settings from './pages/settings';
import Integration from './pages/integration';
// import Login from "pages/login";
import SignupPage from './pages/signup';
import ProtectedRoute from './auth/ProtectedRoute';
import OrderConfirmation from './pages/order-confirmation';
import NDRManagement from './pages/ndr-management';
import AddressConfirmation from "pages/address-confirmation";
import ShoppingAssistance from "pages/shopping-assistance";
import Campaigns from './pages/campaigns';
import CampaignDetail from './pages/campaigns/CampaignDetail';
import AudiencePage from './pages/audience';
import AudienceDetail from './pages/audience/AudienceDetail';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        {/* <Route path="/" element={<Login />} /> */}
        <Route path="/" element={<SignupPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route element={<ProtectedRoute />}>
        <Route path="/escalations-monitoring" element={<EscalationsMonitoring />} />
        <Route path="/knowledge-base-analytics" element={<KnowledgeBaseAnalytics />} />
        <Route path="/analytics-overview" element={<AnalyticsOverview />} />
        <Route path="/agent-performance" element={<AgentPerformance />} />
        <Route path="/call-history-analytics" element={<CallHistoryAnalytics />} />
        <Route path="/integration" element={<Integration />} />
        <Route path="/nps-analytics" element={<NPSAnalytics />} />
        <Route path="/order-confirmation" element={<OrderConfirmation />} />
        <Route path="/ndr-management" element={<NDRManagement />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/address-confirmation" element={<AddressConfirmation />} />
        <Route path="/shopping-assistance" element={<ShoppingAssistance />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/campaigns/:id" element={<CampaignDetail />} />
        <Route path="/audience" element={<AudiencePage />} />
        <Route path="/audience/:id" element={<AudienceDetail />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;